import MainHero from "./MainHero";

export default MainHero;
